import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";



function PJAddonSelector(props) {

    const { state, dispatch, data } = useContext(PJContext);

    function isAddonSelected(group, addon){
        return (state.selectedAddons[group.id] === addon);
    }
    function isStandaloneSelected(addon) {
        return (state.standaloneSelected[addon.id] === addon);
    }
    function isAddonDisabled(addon) {
        return (state.disabledAddons[addon.id] === true);
    }


    function formatTitle(str) {
        //change intl to Internatonal. Remove REVTV

        return str.replace(/intl/ig, 'international').replace('<strong>REV</strong>TV','');
    }

    return  (
        <div className={'col-12 addon-selector step-1a'}>
            <h5 className={'center'} id="select-addons">Choose your add-ons</h5>
            <div className={'addon-groups'}>
                {data.addons.groups.map((group, i) => {
                    return (
                        (group.addons.length > 0 || group.standalone.length > 0) &&
                        <div className={'group'} key={group.id}>
                            <header style={(group.banner) ? {backgroundImage:"url("+group.banner+")"} : {}}>
                                <figure className="addon-group-icon" style={(group.icon) ? {backgroundImage:"url("+group.icon+")"} : {}} />
                                <h3 className={'center'}  dangerouslySetInnerHTML={{__html: formatTitle(group.title)}} />
                            </header>
                            {group.disable ? (
                                <div>
                                    <div className="disabled-group" dangerouslySetInnerHTML={{__html: group.disable}} />
                                </div>
                            ) : (
                                <article className={'addons'}>
                                    <div className={'container'}>
                                        <div className={'row no-padding'}>
                                            {group.addons.map((addon, i) => {
                                                return (
                                                    <div className={'addon theme-' +
                                                        addon.theme + ' ' +
                                                        ((isAddonSelected(group, addon))?'selected':'') +
                                                        (
                                                            (group.gridMode === 'sports')?' col-sm-6 col-xs-6 group-sports':
                                                            (
                                                                (group.gridMode === 'extra')?' col-sm-12 col-xs-12 group-sports':
                                                                ' col-sm-3 col-xs-6'
                                                            )
                                                        )
                                                    } key={addon.id}>
                                                        <div className={'wrapper center'}>
                                                            <h5 className={'center'} dangerouslySetInnerHTML={{__html: addon.title}} />
                                                            <div className={'price center'}>
                                                                <div className="regular">
                                                                    <span className="number" dangerouslySetInnerHTML={{__html: supFractions(addon.price)}} />
                                                                    {group.hasSeasonPrice ? (
                                                                        <span className="period">per month {addon.seasonPrice && '+'}</span>
                                                                    ) : (
                                                                        <span className="period">&nbsp;</span>
                                                                    )}
                                                                </div>
                                                                {group.hasSeasonPrice &&
                                                                    <div className="season">
                                                                        {addon.seasonPrice ? (
                                                                            <>
                                                                                <span className="number" dangerouslySetInnerHTML={{__html: supFractions(addon.seasonPrice)}} />
                                                                                <span className="period">per season</span>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <span className="number">&nbsp;</span>
                                                                                <span className="period">&nbsp;</span>
                                                                            </>
                                                                        )}

                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className={'highlights center ' + ((group.gridMode === 'movies' && addon['addon-channels'].length > 0) ? 'has-addons':'')}>{addon.highlight}
                                                                {(group.gridMode === 'movies' && addon['addon-channels'].length > 0) &&
                                                                    <div className="addons-channels-tip">
                                                                        <div className="addon-channels">
                                                                            <div className="addon-channel">
                                                                                Includes:
                                                                            </div>
                                                                            {addon['addon-channels'].map((channel, i) => {
                                                                                return (
                                                                                    <div className="addon-channel">
                                                                                        {channel.title}
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className={"select-button wp-block-button aligncenter is-style-outline"}>
                                                                <button className={"wp-block-button__link has-text-color "  + ((isAddonSelected(group, addon))?'has-light-red-background-color has-white-color ':'has-light-red-color has-white-background-color')} onClick={e => dispatch({ type: CONSTS.SELECT_ADDON, args: {addon: addon, group: group} })}>Select</button>
                                                            </div>
                                                            <div className={'center small-font mt-4'}> <a href={addon.url} className={'arrow-link center'}>Or find out more</a></div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                            {(group.gridMode === 'sports') &&
                                                <div className="season-tickets col-xs-6">
                                                    <div className="wrapper">
                                                        <h5 className="center">Season tickets</h5>
                                                        <div className="cta"
                                                             dangerouslySetInnerHTML={{__html: (group['sports-addon'].content)}}/>
                                                        <div className="checkbox">
                                                            <label htmlFor="season-tickets-checkbox"><input
                                                                name="season-tickets-checkbox"
                                                                id="season-tickets-checkbox" type="checkbox"
                                                                onChange={e => dispatch({ type: CONSTS.SEASON_TICKETS_TOGGLE, args: {} })}
                                                                checked={state.seasonTickets}
                                                            /><span
                                                                dangerouslySetInnerHTML={{__html: (group['sports-addon'].checkbox)}}/></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        {(group.standalone.length>0 && group.addons.length>0) &&
                                            <div className="row">
                                                <div className="col-12">
                                                    <p className="mt-3 center">or select individual packages</p>
                                                </div>
                                            </div>
                                        }
                                        <div className={'row no-padding'}>

                                            {group.standalone.map((addon, i) => {
                                                return (
                                                    <div className={'addon col-xs-12 standalone theme-' +
                                                        addon.theme +
                                                        ((isStandaloneSelected(addon))?' selected ':'') +
                                                        ((isAddonDisabled(addon))?' disabled ':'') +
                                                        ' group-' + group.slug +
                                                        ((group.gridModeStandalone === 'single')?' col-sm-12 ':' col-sm-6 ')
                                                    } key={addon.id}>
                                                        <div className="container">
                                                            <div className="row no-gutters">
                                                                <div className={"col-xs-3 logo"}>
                                                                    {addon.icon &&
                                                                        <figure className="banner-image m-auto d-flex">
                                                                            <img srcSet={addon.icon} alt="Logo" className="m-auto" />
                                                                        </figure>
                                                                    }
                                                                </div>
                                                                <div className={"heading-cell col-xs-3 d-flex xs-clearfix m-auto"}>
                                                                    <div className="heading-container d-flex my-auto">
                                                                        <h5 className={'my-auto'} dangerouslySetInnerHTML={{__html: addon.title}} />
                                                                    </div>
                                                                </div>
                                                                {addon.highlight &&
                                                                <div className="col-xs-3 copy-cell xs-clearfix my-auto highlight">
                                                                    <div className={''}>{addon.highlight}</div>
                                                                </div>
                                                                }
                                                                <div className="col-xs-3 copy-cell xs-clearfix my-auto">
                                                                    <div className={'price center my-auto'} dangerouslySetInnerHTML={{__html: supFractions(addon.price)}} />
                                                                </div>
                                                                <div className="col-xs-3 cta xs-clearfix my-auto">
                                                                    <div className={"select-button wp-block-button aligncenter is-style-outline"}>
                                                                        <button className={"wp-block-button__link has-text-color "  + ((isStandaloneSelected(addon))?'has-white-color has-light-red-background-color':'has-light-red-color has-white-background-color')} onClick={e => dispatch({ type: CONSTS.SELECT_STANDALONE_ADDON, args: {addon: addon} })} disabled={isAddonDisabled(addon)}>Select</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </article>
                            )}
                        </div>
                    );
                })}
            </div>
            <div className={'standalone-addons'}>
                {data.addons.standalone.map((addon, i) => {
                    return (
                        <div className={'addon col-12 theme-' + addon.theme + ' ' +  ((isStandaloneSelected(addon))?'selected':'') + ((addon.bannerImage)?'':'no-image')} key={addon.id}>
                            <div className="container">
                                <div className="row no-gutters">
                                    {addon.bannerImage &&
                                    <div className={'col-sm-3 col-xs-6 figure-cell'} >
                                            <figure className="banner-image" style={{backgroundImage:"url(" + addon.bannerImage + ")"}}>
                                                &nbsp;
                                            </figure>
                                    </div>
                                    }
                                    <div className={"right-side d-sm-flex no-gutters col-xs-"+ (addon.bannerImage ? 6 : 12) + " flex-sm-row flex-xs-column  col-sm-" + (addon.bannerImage ? 9 : 12)}>
                                        <div className="wrapper d-sm-flex">
                                            <div className={"heading-cell col-xs-12 d-flex xs-clearfix m-auto col-sm-" + (4 + (addon.bannerImage ? 0 : 2) + (addon.highlight ? 0 : 2))}>
                                                <div className="heading-container d-flex m-auto">
                                                    <h5 className={'center my-auto'} dangerouslySetInnerHTML={{__html: addon.title}} />
                                                    <div className="my-auto"> | </div>
                                                    <div className={'price center my-auto'} dangerouslySetInnerHTML={{__html: supFractions(addon.price)}} />
                                                </div>
                                            </div>
                                            {addon.highlight &&
                                            <div className="col-sm-4 col-xs-12 copy-cell xs-clearfix my-auto">
                                                <p className={'highlights small-font'} dangerouslySetInnerHTML={{__html:addon.highlight}} />
                                            </div>
                                            }
                                            <div className="col-sm-4 col-xs-12 cta xs-clearfix my-auto">
                                                <div className={"select-button wp-block-button aligncenter is-style-outline"}>
                                                    <button className={"wp-block-button__link has-text-color "  + ((isStandaloneSelected(addon))?'has-white-color has-light-red-background-color':'has-light-red-color has-white-background-color')} onClick={e => dispatch({ type: CONSTS.SELECT_STANDALONE_ADDON, args: {addon: addon} })}>Select</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export { PJAddonSelector };